import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef } from 'react';
import { UnderlineNav } from '@primer/react';
import LTCounterLabel from '../LTCounterLabel/index.js';
import { VariantStyles, Variants } from './variants.js';
import { createUniqueID, isEnterOrSpacePressed, focusTabOnArrow } from '../../utils/functions.js';
import LTSelect from '../LTSelect/index.js';
import styled from 'styled-components';

var NavContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var isResponsive = _a.isResponsive;
  return isResponsive && "\n    @media only screen and (max-width: 1024px) {\n      display: none;\n    }\n  ";
});
var SelectContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n  @media only screen and (max-width: 1024px) {\n    display: inline-block;\n    margin: 10px;\n  }\n"], ["\n  display: none;\n  @media only screen and (max-width: 1024px) {\n    display: inline-block;\n    margin: 10px;\n  }\n"])));
var VisuallyHiddenContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n"], ["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n"])));
/**
 * Tabs component.
 * @param {string} ariaLabel
 * @param {string} className The classname to be added to the main container element.
 * @param {!Object<string, string>} styles Custom styles to be attached to the container element.
 * @param {function} onClick Callback to be invoked once user clicks on the nav item
 * @param {string} linkClassName Class to be attached to the individual link element.
 * @param {!Object<string, *>} navs The navigation list to be rendered
 *    Sample Object
 *      [{
 *        counter: Optional count to be added to the nav item.
 *        id: 'Unique ID'
 *        isSelected: Whether the current nav item should be selected
 *        key: Identifier for the nav item.
 *        label: The label to be displayed on the nav item.
 *      }]
 * @param {string} variant Styles for the nav list.
 * @param {string} selectedVariant  Styles for the selected nav list.
 */
var LTUnderlineNav = function LTUnderlineNav(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "" : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    _d = _a.linkClassName,
    linkClassName = _d === void 0 ? "" : _d,
    _e = _a.itemStyles,
    itemStyles = _e === void 0 ? {} : _e,
    _f = _a.navs,
    navs = _f === void 0 ? [] : _f,
    _g = _a.onClick,
    onClick = _g === void 0 ? function () {} : _g,
    _h = _a.selectedVariant,
    selectedVariant = _h === void 0 ? Variants.HEADING : _h,
    _j = _a.styles,
    styles = _j === void 0 ? {} : _j,
    _k = _a.onKeyDown,
    onKeyDown = _k === void 0 ? function () {} : _k,
    _l = _a.variant,
    variant = _l === void 0 ? Variants.PRIMARY : _l,
    leadingText = _a.leadingText,
    _m = _a.isResponsive,
    isResponsive = _m === void 0 ? true : _m;
  var navLinksRef = useRef([]);
  function handleNavigationClick(key, isClickedViaKeyboard, index) {
    if (isClickedViaKeyboard === void 0) {
      isClickedViaKeyboard = false;
    }
    return function (event) {
      if (isClickedViaKeyboard) {
        if (isEnterOrSpacePressed(event)) {
          onClick({
            key: key,
            event: event
          });
        } else {
          var lastIndex = navs.length - 1;
          focusTabOnArrow(event, "horizontal", navLinksRef, index, lastIndex);
        }
      } else {
        onClick({
          key: key,
          event: event
        });
      }
    };
  }
  var ltSelectOptions = navs.map(function (nav) {
    return {
      name: "".concat(nav.label, " ").concat(nav.counter && nav.counter > 0 ? "(".concat(nav.counter, ")") : ""),
      value: nav.key,
      isSelected: nav.isSelected
    };
  });
  var getSelectedOptions = function getSelectedOptions() {
    return ltSelectOptions.find(function (option) {
      return option.isSelected;
    });
  };
  var navId = createUniqueID("underlineNav");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHiddenContainer, {
    id: navId
  }, ariaLabel), isResponsive && /*#__PURE__*/React.createElement(SelectContainer, null, /*#__PURE__*/React.createElement(LTSelect, {
    leadingText: leadingText,
    options: ltSelectOptions,
    onChange: function onChange(options) {
      return onClick({
        key: options[0].value
      });
    },
    defaultSelections: [getSelectedOptions()]
  })), /*#__PURE__*/React.createElement(NavContainer, {
    isResponsive: isResponsive
  }, /*#__PURE__*/React.createElement(UnderlineNav, {
    "aria-orientation": "horizontal",
    "aria-labelledby": navId,
    className: className,
    role: "tablist",
    sx: __assign({
      "> div": {
        gap: "8px"
      }
    }, styles),
    onKeyDown: onKeyDown
  }, navs === null || navs === void 0 ? void 0 : navs.map(function (nav, index) {
    return /*#__PURE__*/React.createElement(UnderlineNav.Link, {
      "aria-controls": (nav === null || nav === void 0 ? void 0 : nav.isSelected) ? nav === null || nav === void 0 ? void 0 : nav.contentId : undefined,
      "aria-selected": nav === null || nav === void 0 ? void 0 : nav.isSelected,
      className: linkClassName,
      selected: nav === null || nav === void 0 ? void 0 : nav.isSelected,
      onClick: handleNavigationClick(nav === null || nav === void 0 ? void 0 : nav.key),
      onKeyDown: handleNavigationClick(nav === null || nav === void 0 ? void 0 : nav.key, true /* isClickedViaKeyboard */, index),
      id: nav === null || nav === void 0 ? void 0 : nav.id,
      key: index,
      sx: __assign(__assign(__assign({}, VariantStyles[(nav === null || nav === void 0 ? void 0 : nav.isSelected) ? selectedVariant : variant]), {
        marginRight: "0px",
        "> span[data-content]:before": {
          content: "attr(data-content)",
          display: "block",
          height: "0px",
          fontWeight: VariantStyles[selectedVariant].fontWeight,
          visibility: "hidden",
          whiteSpace: "nowrap"
        },
        "&:focus-visible:not(:disabled)": {
          outline: "2px solid #101010 !important"
        },
        "&:hover": {
          cursor: "pointer"
        }
      }), itemStyles),
      ref: function ref(el) {
        return navLinksRef.current[index] = el;
      },
      role: "tab",
      tabIndex: (nav === null || nav === void 0 ? void 0 : nav.isSelected) ? 0 : -1
    }, (nav === null || nav === void 0 ? void 0 : nav.leadingIcon) && /*#__PURE__*/React.createElement(nav.leadingIcon, null), /*#__PURE__*/React.createElement("span", {
      "data-content": nav === null || nav === void 0 ? void 0 : nav.label
    }, nav === null || nav === void 0 ? void 0 : nav.label), (nav === null || nav === void 0 ? void 0 : nav.counter) || (nav === null || nav === void 0 ? void 0 : nav.counter) === 0 ? /*#__PURE__*/React.createElement(LTCounterLabel, {
      count: nav === null || nav === void 0 ? void 0 : nav.counter
    }) : /*#__PURE__*/React.createElement(React.Fragment, null));
  }))));
};
var templateObject_1, templateObject_2, templateObject_3;

export { LTUnderlineNav as default };
